import { render, staticRenderFns } from "./u-card-icon.vue?vue&type=template&id=2c65c008&"
import script from "./u-card-icon.vue?vue&type=script&lang=js&"
export * from "./u-card-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports